import * as React from 'react';
import { Permissions } from '../../../../models/enums/permissions';
import { ContainerRead } from '../../../../transportation/models/containers/container-read';
import { EditRouteStatus } from '../../../../transportation/components/shipments/EditRouteStatus';
import { ShipmentDocuments } from '../../../../transportation/components/shipments/ShipmentDocuments';

interface IProps {
    container: ContainerRead;
    updateContainerState: any;
}

export const EditContainerSidebar = (props: IProps) => {
    return <div className="col-3 shipment-sidebar">

                {/* Status Control */}
                <EditRouteStatus 
                    route={ props.container }
                    requiredPermission={ Permissions.ShippingContainersEdit }
                    updateRouteState={ props.updateContainerState }
                /> 

                {/* Documents Control */}
                <ShipmentDocuments route={ props.container } />

            </div>;        
};
